import styled from '../../config/theme';

const BaseSvgWrapper = styled.span`
  display: flex;

  svg {
    width: 28px;
    height: 28px;
  }
`;

export default BaseSvgWrapper;
